import { Offcanvas } from 'react-bootstrap';
import type { TaskFilterProps } from './model/types';
import useTaskFilter from './model/useTaskFilter';
import TaskFilterButton from './partials/TaskFilterButton';
import TaskFilterFooter from './partials/TaskFilterFooter';
import TaskFilterForm from './partials/TaskFilterForm';

const TaskFilter = (props: TaskFilterProps) => {
    const filter = useTaskFilter(props);
    const { showExecutorFilter = false, showControllerFilter = false } = props;
    const { t, show, hasActiveFilter, handleHide, handleOpen, handleApply, handleReset } = filter;

    return (
        <>
            <TaskFilterButton active={hasActiveFilter} title={t('toolTaskFilter')} onOpen={handleOpen} />

            <Offcanvas
                show={show}
                onHide={handleHide}
                placement="end"
                backdrop
                backdropClassName="task-filter-offcanvas-backdrop"
                className="task-filter-offcanvas"
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title>{t('toolTaskFilter')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                    <div className="off-filter-form d-flex flex-column h-100">
                        <TaskFilterForm
                            filter={filter}
                            showExecutorFilter={showExecutorFilter}
                            showControllerFilter={showControllerFilter}
                        />
                        <TaskFilterFooter
                            resetLabel={t('common:buttons.reset')}
                            applyLabel={t('common:buttons.apply')}
                            onReset={handleReset}
                            onApply={handleApply}
                        />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default TaskFilter;
